import React, { useEffect, useState } from "react";
import { Box, FormControl } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";

function Paginator(props) {
  const { label, data, showItemsPerPage, onChangePage } = props;
  const pageCount = showItemsPerPage;
  const totalData = data;
  const [noOfPages, setNoOfPages] = useState(1);
  const [skipRecords, setSkipRecords] = useState(0);

  useEffect(() => {
    setNoOfPages(Math.ceil(localStorage.getItem("purchaseCount")/ pageCount));
    onChangePage(totalData.slice(skipRecords, pageCount));
  }, [pageCount]);

  const onChangePageNumber = (event, page) => {
    event.preventDefault();
    let skip = (page - 1) * pageCount;
    setSkipRecords(skip);
    onChangePage(totalData.slice(skip, skip + pageCount),page);

  };

  return (
    <div>
      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        p={2}
        className="custompagination1"
      >
        <Box pr={2}> {label} </Box>
        <Box pr={2}>
          <FormControl>
          </FormControl>
        </Box>
        <Pagination
          count={noOfPages}
          color="primary"
          variant="outlined"
          onChange={onChangePageNumber}
        />
      </Box>
    </div>
  );
}

export default Paginator;
